/* @flow */

import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';

import IntlMessageComponent from 'components/formatters/intlMessage';
import LoadingComponent from 'components/loading';

import ConfirmingTypeForm from './model';
import { COMPANY_TYPE_CONFIRMING, COMPANY_TYPE_SUPPLIER } from 'constants/constants';

type ConfirmingTypeDialogViewComponentProps = {
  errors: Map<string,?string>;
  form: ConfirmingTypeForm;
  formErrors: string[];
  isProcessing: boolean;
  handleCancel: () => void;
  handleChange: (fieldName: string) => (event: SyntheticInputEvent<HTMLInputElement>) => void;
  submitForm: () => void;
}

export default function ConfirmingTypeDialogViewComponent(props: ConfirmingTypeDialogViewComponentProps) {

  const onChange = (event) => props.handleChange(parseInt(event.target.value));

  const confirmingTypes = [COMPANY_TYPE_CONFIRMING, COMPANY_TYPE_SUPPLIER];
  return (
    <React.Fragment>
      <Dialog open onClose={props.handleCancel}>
        {props.isProcessing && <LoadingComponent />}
        {!props.isProcessing && <React.Fragment>
          <DialogTitle><IntlMessageComponent id="form.confirmingType.title" /></DialogTitle>

          <DialogContent>
            <FormControl component="fieldset">
              <RadioGroup
                aria-label="confirmingType"
                name="form.confirmingType"
                value={props.form.confirmingType.toString()}
                onChange={onChange}
              >
                {confirmingTypes.map(confirmingType => (
                  <FormControlLabel
                    key={`radio-${confirmingType}`}
                    value={confirmingType.toString()}
                    control={<Radio color="primary" />}
                    label={<IntlMessageComponent id={`form.companytype.option${confirmingType}.modal.label`} />} />
                ))}
              </RadioGroup>
            </FormControl>
          </DialogContent>

          <DialogActions>
            <Button onClick={props.handleCancel} color="default">
              <IntlMessageComponent id="debtor.approve.approvePopup.btn.cancel" />
            </Button>
            <Button onClick={props.submitForm} disabled={props.form.confirmingType <= 0} color="primary">
              <IntlMessageComponent id="debtor.approve.approvePopup.btn.confirm" />
            </Button>
          </DialogActions>
        </React.Fragment>}
      </Dialog>
    </React.Fragment>
  );
}
